import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { customerInformationsReducer } from '../services/DataServices/CustomerInformationService/reducers';
import { customerDetailsReducer } from '../services/DataServices/CustomerDetailsService/reducers';
import { customerAddressReducer } from '../services/DataServices/CustomerAddressService/reducers';
import { customerQuotationReducer } from '../services/DataServices/CustomerQuotationService/reducers';

import { accountReducer } from '../services/SFAccountService/reducers';
import { opportunityReducer } from '../services/SFOpportunityService/reducers';
import { shippingAddressReducer } from '../services/SFShippingAddressService/reducers';
import { quotationReducer } from '../services/SFQuotationService/reducers';

import { googleDriveReducer } from '../services/DriveService/reducer';

import { tillerBackReducer } from '../services/TillerBackService/reducers';

import { navigationReducer } from '../services/NavigationService/reducers';

const rootReducer = combineReducers({
  form: formReducer,
  customerInformations: customerInformationsReducer,
  customerDetails: customerDetailsReducer,
  customerAddress: customerAddressReducer,
  customerQuotation: customerQuotationReducer,
  account: accountReducer,
  opportunity: opportunityReducer,
  shippingAddress: shippingAddressReducer,
  quotation: quotationReducer,
  drive: googleDriveReducer,
  step: navigationReducer,
  tillerBack: tillerBackReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js